/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_LocationInputs */

const de__field_location = /** @type {(inputs: _Field_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort CHANCENschule`)
};

/**

* @param {_Field_LocationInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_location = /** @type {((inputs?: _Field_LocationInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_LocationInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_location(inputs)
});